import { StackView, Spinner, Button, Text } from '@planningcenter/tapestry-react';
import React, { useState, useEffect } from 'react';
import { Subheading } from '../ui/subheading.js';
import { useServicesChatShortcuts } from './hooks/use_services_chat_shortcuts.js';

const DEFAULT_SHORTCUT_COUNT = 4;
const ServicesChatShortcuts = ({ isActive, setFilterValues, switchToNewServicesChatView, }) => {
    const [showAll, setSetshowAll] = useState(false);
    const { loading, serviceTypeTeams } = useServicesChatShortcuts(isActive);
    useEffect(() => {
        if (!isActive)
            setSetshowAll(false);
    }, []);
    const hasMore = serviceTypeTeams.length > DEFAULT_SHORTCUT_COUNT;
    return (React.createElement(StackView, null,
        React.createElement(StackView, { alignment: "center", axis: "horizontal", distribution: "space-between", paddingBottom: 1, paddingHorizontal: 2, spacing: 1 },
            React.createElement(StackView, { alignment: "center", axis: "horizontal", spacing: 1 },
                React.createElement(Subheading, null, "Teams I lead"),
                loading && React.createElement(Spinner, { size: "xs" })),
            React.createElement(Button, { icon: "general.search", marginLeft: "auto", onClick: switchToNewServicesChatView, size: "sm", title: "Search all teams", tooltip: "Search all teams", variant: "outline" })),
        serviceTypeTeams.length === 0 ? (React.createElement(NoTeams, { onClick: switchToNewServicesChatView })) : (React.createElement(StackView, { spacing: 1.5, paddingBottom: 1 },
            React.createElement(StackView, null, serviceTypeTeams
                .slice(0, showAll ? undefined : DEFAULT_SHORTCUT_COUNT)
                .map(({ id, name, teams }) => (React.createElement(Button, { alignment: "start", "aria-label": `Select ${name} teams I lead`, axis: "vertical", borderBottomColor: "separatorTertiary", borderBottomStyle: "solid", borderBottomWidth: 1, hover: { backgroundColor: "surfaceSecondary" }, key: id, paddingHorizontal: 2, paddingVertical: 1, spacing: 0.25, textAlign: "left", theme: false, onClick: () => {
                    setFilterValues({
                        appName: "Services",
                        values: {
                            plan_id: null,
                            teams: teams.map((team) => ({
                                service_type_id: id,
                                team_id: team.id,
                            })),
                        },
                    });
                    switchToNewServicesChatView();
                } },
                React.createElement(Text, { weight: 500 }, name),
                React.createElement(Text, { color: "foregroundSecondary" }, teams.map((team) => team.name).join(", ")))))),
            hasMore && (React.createElement(StackView, { alignment: "center" },
                React.createElement(Button, { fontWeight: 400, iconLeft: {
                        name: showAll ? "general.upCaret" : "general.downCaret",
                    }, onClick: () => setSetshowAll(!showAll), size: "xs", title: showAll ? "Less teams" : "Show all teams I lead", variant: "outline" })))))));
};
const NoTeams = ({ onClick }) => (React.createElement(StackView, { alignment: "center", axis: "vertical", distribution: "center", height: 20, padding: 2, spacing: 1 },
    React.createElement(Text, { color: "foregroundSecondary" }, "You don't lead any teams."),
    React.createElement(Button, { fontWeight: 400, onClick: onClick, size: "sm", variant: "outline" }, "Browse teams")));

export { ServicesChatShortcuts };
//# sourceMappingURL=service_chat_shortcuts.js.map
